import { Component, OnDestroy, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-session-warning-dialog',
  standalone: true,
  templateUrl: './session-warning-dialog.component.html',
  styleUrls: ['./session-warning-dialog.component.scss'],
  imports: [CommonModule, MatDialogModule, MatButtonModule]
})
export class SessionWarningDialogComponent implements OnInit, OnDestroy {
  countdown: number;
  private intervalId: any;

  constructor(
    private dialogRef: MatDialogRef<SessionWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { countdownSeconds: number }
  ) {
    this.countdown = Math.floor(data?.countdownSeconds ?? 300);
  }

  ngOnInit() {
    this.intervalId = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.logoutNow();
      }
    }, 1000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  extendSession() {
    this.dialogRef.close('stay');
  }

  logoutNow() {
    this.dialogRef.close('logout');
  }
}
